import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  small {
    color: #ff6565;
    font-size: 13.5px;
    font-family: IBM Plex Sans;
    line-height: 12px;
    margin-top: 0.5rem;
  }
  label {
    color: var(--grey-100);
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-bottom: 0.8rem;

  svg {
    width: 1rem;
    height: 1rem;

    margin-right: 0.5rem;

    path {
      stroke: var(--grey-100);
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 3rem;

  > input {
    width: 100%;
    height: 100%;

    padding: 1rem;

    background-color: var(--black-100);

    border: 1px solid transparent;
    border-radius: 0px 5px 5px 0px;

    &:focus {
      outline: 0;
      border-color: var(--primary);
    }

    &:read-only {
      background-color: var(--black-400);
      cursor: default;
    }
  }
`;

export const PreffixContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border-right: 3px solid var(--black-200);
  border-radius: 5px 0px 0px 5px;

  background-color: var(--black-100);

  padding: 1rem;
  height: 100%;

  font-family: IBM Plex Sans, sans-serif;
  font-weight: 700;
  color: var(--grey-100);
`;
